// extracted by mini-css-extract-plugin
export default {"Userpage":"Userpage_Userpage__5tY7M","UserpageMobile":"Userpage_UserpageMobile__yXUFd","UserDiv":"Userpage_UserDiv__wsDXV","UserName":"Userpage_UserName__SRuU5"};